import gql from "graphql-tag"
import SourceAssetFragment from "../fragment/SourceAssetFragment"

export default gql`
  ${SourceAssetFragment}
  mutation sourceAssetIgnore($id: String!) {
    sourceAssetIgnore(id: $id) {
      ...SourceAssetFragment
    }
  }
`
